import { useSearchParams } from "next/navigation"
import { useAppContext } from "@/lib/contexts/appContext"

export const useParsedUrl = ({ url, autoAppend, autoRelative = true }) => {
  const searchParams = useSearchParams()
  const { meta } = useAppContext()

  if (!url) {
    return null
  }

  const newUrl = new URL(url, meta.baseUrl)

  if (autoAppend && searchParams.size > 0) {
    searchParams.forEach((value, key) => {
      if (!newUrl.searchParams.has(key)) {
        newUrl.searchParams.append(key, value)
      }
    })
  }

  // If autoRelative is true and the url contains domain, convert to relative path
  if (autoRelative && newUrl.origin === meta.baseUrl) {
    return newUrl.pathname + newUrl.search + newUrl.hash
  }

  return newUrl.toString()
}
